export const es = {
    GENERAL_DELETE: 'Borrar',
    GENERAL_CANCEL: 'Cancelar',
    GENERAL_SAVE: 'Guardar',
    GENERAL_SETTINGS: 'Ajustes',
    JSON_EDITOR_REVISION_ACTIVE: 'activo',
    JSON_EDITOR_REVISION_DELETE_CONFIRM: '¿Realmente eliminar la revisión?',
    JSON_EDITOR_REVISION_SAVE_SUCCESS: 'Revisión guardada',
    JSON_EDITOR_REVISION_SAVE_FAILURE: 'La revisión no fue guardada',
    JSON_EDITOR_REVISION_DELETE_SUCCESS: 'Revisión eliminada',
    JSON_EDITOR_REVISION_DELETE_FAILURE: 'La revisión no fue eliminada',
    JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED: 'Las revisiones activas no se pueden guardar',
    JSON_EDITOR_REVISION_ACTIVATE_SUCCESS: 'Revisión activada',
    JSON_EDITOR_REVISION_ACTIVATE_FAILURE: 'La revisión no fue activada',
    JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION: 'No se puede cambiar la revisión ya aprobada.',
    JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS: 'No se puede cambiar la revisión de otros administradores',
    JSON_EDITOR_INVALID_JSON: 'JSON inválido',
    MISSING_APPROVAL_PERMISSION: 'No tienes permiso para aprobar las revisiones.',
    DIRECTIVE_PHONE_PRESET_CONFIGURE_GLOBAL: '¿Configurar el teléfono preestablecido globalmente?',
    DIRECTIVE_CHECK_BEFORE_EXPORT_ENABLED: 'Los informes deben ser verificados antes de exportar a integración.',
    DIRECTIVE_EXPORT_SETTINGS_CONFIGURE_GLOBAL: '¿Configurar preferencias globalmente?',
    DIRECTIVE_APP_CRM_CONNECTION_DISABLED: 'Desactivar la conexión CRM en la aplicación de escáner de tarjetas de visita',
    DIRECTIVE_EXPORT_SETTINGS_DIRECT_EXPORT: 'Guarde los datos de contacto directamente en la integración seleccionada (sistema CRM).',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_CONFIGURE_GLOBAL: '¿Configurar la exportación automática a nivel mundial?',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_ENABLED: 'Activar exportación automática',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_TIMEOUT: 'Ejecutar exportación automática después de minutos de inactividad.',
    DIRECTIVE_SELECT_INTEGRATION_CHOOSE: 'Ajustes de integración',
    DIRECTIVE_SELECT_INTEGRATION_CRM_HEADER: 'Sistemas de CRM:',
    DIRECTIVE_SELECT_INTEGRATION_EMAIL_HEADER: 'Integraciones de correo electrónico:',
    DIRECTIVE_SELECT_INTEGRATION_MA_HEADER: 'Marketing automations:',
    DIRECTIVE_SELECT_INTEGRATION_OTHER_HEADER: 'Otras integraciones:',
    DIRECTIVE_VISITREPORT_MANDATORY_CONFIGURE_GLOBAL: '¿Configurar campos de contacto obligatorios a nivel mundial?',
    INTEGRATION_MODAL_SNAPADDY_API_HEADER: 'configuración de la API snapAddy',
    INTEGRATION_MODAL_SNAPADDY_API_ENDPOINT_URL: 'Endpoint-URL',
    INTEGRATION_MODAL_SNAPADDY_API_HTTP_METHOD: 'Método HTTP',
    INTEGRATION_MODAL_SNAPADDY_API_AUTH_HEADER: 'Encabezado de autorización',
    INTEGRATION_MODAL_WECLAPP_HEADER: 'Configuraciones de Weclapp',
    INTEGRATION_MODAL_SUGAR_HEADER: 'Configuraciones de SugarCRM',
    INTEGRATION_MODAL_SUITE_HEADER: 'Configuraciones de SuiteCRM',
    INTEGRATION_MODAL_SUGAR_USE_V41: 'Utilizo la Sugar Community Edition',
    INTEGRATION_MODAL_CENTRALSTATION_HEADER: 'Configuraciones de CentralStationCRM',
    INTEGRATION_MODAL_SAPC4C_HEADER: 'Configuraciones de SAP Sales Cloud',
    INTEGRATION_MODAL_SAGE_HEADER: 'Ajustes',
    INTEGRATION_MODAL_DYNAMICS_HEADER: 'Configuraciones de Microsoft Dynamics',
    INTEGRATION_MODAL_ZAPIER_HEADER: 'Ajustes',
    INTEGRATION_MODAL_SUITE_EXPORT_2: 'CRM Export 2.0 activado',
    INTEGRATION_MODAL_SUITE_PLAINTEXT_PASSWORD: 'Enviar contraseña en texto sin formato (La contraseña no se guardará)',
    INTEGRATION_MODAL_GENERIC_ENDPOINT_URL: 'Endpoint-URL',
    INTEGRATION_MODAL_OPTIVO_HEADER: 'Episerver Campaign configuración',
    INTEGRATION_MODAL_OPTIVO_AUTHTOKEN: 'Código de Autorización',
    INTEGRATION_MODAL_OPTIVO_AUTO_EXPORT: 'Enviar automáticamente informes a Episerver Campaign después de verificar',
    INTEGRATION_MODAL_OPTIVO_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/episerver-campaign-authorization-code-and-mailingid',
    INTEGRATION_MODAL_MANDRILL_HEADER: 'Configuración de Mandrill/MailChimp',
    INTEGRATION_MODAL_MANDRILL_API_KEY: 'Clave API',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_TEMPLATE: 'Nombre de plantilla predeterminado',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_EMAIL: 'Email Remitente Estándar',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_NAME: 'Nombre predeterminado del remitente',
    INTEGRATION_MODAL_MANDRILL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/mandrill-api-key-and-template-name',
    INTEGRATION_MODAL_RAPID_MAIL_HEADER: 'Ajustes de RapidMail',
    INTEGRATION_MODAL_RAPID_MAIL_USER_NAME: 'Nombre de usuario API',
    INTEGRATION_MODAL_RAPID_MAIL_PASSWORD: 'Contraseña API',
    INTEGRATION_MODAL_RAPID_MAIL_INVALID_CREDENTIALS: 'Por favor ingrese las credenciales de usuario de RapidMail API',
    INTEGRATION_MODAL_RAPID_MAIL_AUTO_EXPORT: 'Enviar automáticamente informes a RapidMail después de verificar',
    INTEGRATION_MODAL_RAPID_MAIL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/rapidmail-api-user-api-password-and-recipient-list-id',
    INTEGRATION_MODAL_HUBSPOT_HEADER: 'Ajustes de Hubspot',
    INTEGRATION_MODAL_HUBSPOT_API_KEY: 'API Key',
    INTEGRATION_MODAL_HUBSPOT_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/hubspot-access-token',
    INTEGRATION_MODAL_SET_DEFAULT_CRM: 'Definir CRM por defecto',
    INTEGRATION_MODAL_SALESFORCE_HEADER: 'Configuraciones de Salesforce',
    INTEGRATION_MODAL_CLOSEIO_HEADER: 'Configuraciones de Close.io',
    INTEGRATION_MODAL_OUTLOOK_HEADER: 'Configuraciones de Outlook',
    REMOVE_SETTINGS_REQUEST: '¿Quieres eliminar la configuración de forma permanente?',
    INT_DYNAMICS_OAUTH_LOGIN: 'Conectar a través de OAuth',
    INT_DYNAMICS_OAUTH_LOGIN_RESTRICTION: '(solo para Dynamics CRM 365 Online)',
    INT_DYNAMICS_USE_API: 'Usar conexión API',
    INT_DYNAMICS_USE_LINK: 'Utilizar URL de exportación (sin verificación de duplicados)',
    INT_DYNAMICS_WEB_SESSION: 'Usar sesión web existente',
    INT_DYNAMICS_WINDOWS: 'Usa windows-login',
    INT_SAP_LOGIN_TYPE: 'Tipo de conexión',
    INT_SAP_OAUTH_CLIENT_ID: 'OAuth Client ID',
    INT_SAP_OAUTH_CLIENT_SECRET: 'OAuth Client Secret',
    INT_SAP_USE_WEBSESSION: 'Usar sesión web existente',
    INT_SAP_USE_OAUTH: 'OAuth 2.0 via SAML Bearer Assertion',
    INT_SAP_ENTITY_ID: 'Entity ID',
    INTEGRATION_MODAL_GENERIC_PLEASE_CHOOSE: 'Por favor seleccione ...',
    Salutation: 'Saludo',
    Title: 'Título',
    Vorname: 'Nombre',
    Nachname: 'Apellido',
    Firma: 'Empresa',
    Funktion: 'Posición',
    Straße: 'Calle',
    Adresszusatz: 'Línea de dirección 2',
    PLZ: 'Zip',
    Ort: 'Ciudad',
    Telefon: 'Teléfono',
    Mobile: 'Móvil',
    Fax: 'Fax',
    'E-Mail': 'Email',
    Website: 'Sitio web',
    Land: 'País',
    Bundesland: 'Estado',
    Kontaktdaten: 'Detalles de contacto',
};
